import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  height: 30px;
  margin-top: 10px;
`;

export const SearchBar = styled.input`
  width: 100%;
  height: 30px;
  border-radius: 50px;
  border: 1px solid #ebebeb;
  padding: 7px 11px;
  margin-right: 15px;
  outline: none;
  font-size: 14px;
  color: #333333;
`;
